module.exports = __webpack_public_path__ + "img/important-project-left.c399226f.png";